import { render, staticRenderFns } from "./publicInfoMore.vue?vue&type=template&id=0c3d4478&scoped=true"
import script from "./publicInfoMore.vue?vue&type=script&lang=js"
export * from "./publicInfoMore.vue?vue&type=script&lang=js"
import style0 from "./publicInfoMore.vue?vue&type=style&index=0&id=0c3d4478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3d4478",
  null
  
)

export default component.exports